module.exports = __webpack_public_path__ + "c7efee461f5e8f668f26b2c36f62096a.ttf";